import React from 'react';
import { Table, TableHead, TableBody, TableRow, TableCell, IconButton, SvgIcon, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles'
import { browserHistory } from 'react-router'
import { FORM_SETTINGS_VIEW } from '../actions/main'
import { ReactComponent as EditIcon } from '../styles/images/edit.svg'
import { ReactComponent as DuplicateIcon } from '../styles/images/duplicate.svg'
import { ReactComponent as TrashIcon } from '../styles/images/trash.svg'


const useStyles = makeStyles({
    table:{
        marginTop: 20
    },
    tableHead: {
        display: 'block'
    },
    tableBody:{
        display: 'block',
        minHeight: 500,
        maxHeight: 450,
        overflow: 'hidden',
        overflowY: 'auto'
    },
    tableRow:{
        '&:hover':{
            backgroundColor: '#dfdfdf'
        },
        '&.selected':{
            backgroundColor: '#cdcdcd'
        }
    },
    nameField:{
        width: 260,
        fontFamily: 'Asap-Italic',
        fontSize: 14,
        color:'#666666',
        padding: '6px 10px',
        cursor: 'pointer',
        borderLeft: 'transparent 6px solid',
        '&:hover, &.selected':{            
            transform: 'translate(10px, 0)',
            borderLeftColor: '#707070'
        },
        '&.selected':{
            fontWeight: 'bold'            
        },
        
        transition: 'transform 0.2s ease'
    },
    buttonsField:{
        padding: 0
    },
    invisibleBtn:{
        background:'transparent',
        boxShadow: 'none',
        '&:disabled': {
            background:'transparent'
        }
    },
    actionBtn:{
        boxShadow: 'none',
        background:'transparent'
    },
    svgIcon: {
        stroke: '#515151',
        fontSize: 18,
        strokeMiterlimit:10,
        strokeLinecap:'round',
        strokeLinejoin: 'round',
        strokeWidth:'1px',
        fill:'#515151',
        '&:hover': {
            stroke: '#f5b01b',
            '& .trash':{
                fill:'#f5b01b',
                stroke: '#f5b01b',
                strokeWidth: '0.3px'
            },
            '& .duplicate':{
                '&.a': {
                    fill:'#f5b01b',
                    stroke: '#f5b01b'                    
                },
                '&.b': {
                    stroke: '#f5b01b'                    
                },
                '&.c': {
                    fill:'#f5b01b'
                }
            }
        },
        '& .edit':{
            fill: 'none'
        },
        '& .duplicate':{
            '&.a': {
                stroke: '#515151',
                strokeWidth:'0.119px'
            },
            '&.b': {
                stroke: '#515151',
                strokeWidth:'0.747px',
                fill: 'none',
            }
        },
        '& .trash':{
            stroke:'#515151',
            strokeWidth: '0.3px'
        }
    }
})

const FormList = ({ deleteForm, duplicateForm, selectForm, forms, main, changeView, getForm, selectDefaultEditTab }) => {
    const classes = useStyles()
    const handleEdit = id => {
        // set the tab to the default for editing
        selectDefaultEditTab();
        changeView(FORM_SETTINGS_VIEW);
        let url = `/settings/${id}`;
        browserHistory.push(url);
    }

    const handleSelectForm = form => {
        selectForm(form)
        getForm(form.FormId, true)
    }

    return (
        <Table className={classes.table}>
            <TableHead className={classes.tableHead}>
                {/* <TableRow>
                    <TableCell className={classes.nameField}>Name of form</TableCell>
                    <TableCell  className={classes.buttonsField}>
                        <IconButton size="small" disabled className={classes.invisibleBtn}><span></span></IconButton>
                        <IconButton size="small" disabled className={classes.invisibleBtn}><span></span></IconButton>
                        <IconButton size="small" disabled className={classes.invisibleBtn}><span></span></IconButton>
                    </TableCell>                    
                </TableRow> */}
            </TableHead>
            <TableBody className={classes.tableBody}>
                {forms.map(form =>{
                    return(
                        <TableRow key={form.FormId} className={ main.selectedForm !== null && main.selectedForm.FormId === form.FormId 
                            ? classes.tableRow + ' selected' 
                            : classes.tableRow}>
                            <TableCell className={ main.selectedForm !== null && main.selectedForm.FormId === form.FormId 
                                ? classes.nameField + ' selected' 
                                : classes.nameField}
                                onClick={() => handleSelectForm(form)}
                            >
                                    {form.Name}
                            </TableCell>
                            <TableCell className={classes.buttonsField}>
                                <Tooltip placement="top" title="Edit">
                                    <IconButton size="small" className={classes.actionBtn} onClick={() => handleEdit(form.FormId)}>
                                        <SvgIcon component={EditIcon} viewBox="0 0 9 14" className={classes.svgIcon} />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip placement="top" title="Delete">
                                    <IconButton size="small" className={classes.actionBtn} onClick={() => deleteForm(form.FormId)}>
                                        <SvgIcon component={TrashIcon} viewBox="0 0 12 14" className={classes.svgIcon} />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip placement="top" title="Duplicate">
                                    <IconButton size="small" className={classes.actionBtn} onClick={() => duplicateForm(form.FormId)}>
                                        <SvgIcon component={DuplicateIcon} viewBox="0 0 10 14" className={classes.svgIcon} />
                                    </IconButton>
                                </Tooltip>
                            </TableCell>                            
                        </TableRow>
                    )
                })}
            </TableBody>
        </Table>
    )
}

export default FormList;